import { SearchProps } from '~components/form-fields/search';

import { selectLocations } from '~appointments/selectors/locations';
import { selectLookupClients } from '~main/selectors/clients/clients';

const fields: SearchProps = {
  client_id: {
    defaultShow: true,
    type: 'multi-lookup',
    field: 'id',
    caption: 'Client',
    placeholder: 'All',
    selectorOptions: selectLookupClients,
  },
  appointment_location: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'filter_by[location_override_id][]',
    caption: 'Appointment Location',
    placeholder: 'All',
    selectorOptions: selectLocations,
  },

  trip_location: {
    defaultShow: false,
    type: 'multi-lookup',
    field: 'filter_by[transport_id][]',
    caption: 'Pickup / Dropoff Location',
    placeholder: 'All',
    selectorOptions: selectLocations,
  },
};

export default fields;
